import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ChatLauncher } from './ChatLauncher';
import { Footer } from './Footer';
import { MegaNav } from './MegaNav';
import { MobileBottomNav } from './MobileBottomNav';
import { RoleDrawer } from './RoleDrawer';
import { Topbar } from './Topbar';
import { RouteFallback } from '@/components/ui/RouteFallback';
import { RoleCabinetChrome } from '@/features/cabinet/RoleCabinetChrome';
import { NavigationStateSync } from '@/features/navigation/NavigationStateSync';
import { isWorkspaceCabinetPath } from '@/lib/navigationState';
import { routes } from '@/lib/routes';
import { useAuth } from '@/hooks/useAuth';

export const AppLayout = () => {
  const location = useLocation();
  const { user } = useAuth();
  const isHome = location.pathname === routes.home;
  // Task 14: second-page chrome only on role/category cabinets — never on home
  // and never on shared /app utilities (profile, create request, tools, …).
  const isRoleCabinet = isWorkspaceCabinetPath(location.pathname);

  return (
    <div className="app-shell" key={user?.id || 'anonymous'}>
      <NavigationStateSync />
      <Topbar />
      <RoleDrawer />
      {/* On home, MegaNav sits under the hero (HTML template order). */}
      {!isHome ? <MegaNav /> : null}
      <main className="app-main" id="main">
        <Suspense fallback={<RouteFallback />}>
          {isRoleCabinet ? (
            <RoleCabinetChrome>
              <Outlet />
            </RoleCabinetChrome>
          ) : (
            <Outlet />
          )}
        </Suspense>
      </main>
      <Footer />
      <ChatLauncher />
      <MobileBottomNav />
    </div>
  );
};
